import React from "react";
import ConnectedTextarea from "components/ConnectedTextarea";
import { getFieldPath } from "utils/form";
import CopyCode from "components/CopyCode";
import get from "lodash/get";
import { useFormikContext } from "formik";
import SectionBezel from "components/SectionBezel";
import { VIEW_ON_STRIPE } from "utils/constants/ui";
import { getStripeDestination } from "utils/stripe";
import { useCtxReferences } from "utils/selectors";
import { getAccountConnectStatusProps } from "utils/merchantAccount";
import StripeExternalLink from "components/StripeExternalLink";

const DetailsFields = ({ name }) => {
  const { values } = useFormikContext();
  const idPath = getFieldPath(name, "id");
  const id = get(values, idPath);

  const { merchantAccount } = useCtxReferences();
  const account =
    merchantAccount && getAccountConnectStatusProps(merchantAccount);

  const primaryFields = (
    <div className="flex flex-column w-100">
      <div className="pb3">
        <ConnectedTextarea
          name={getFieldPath(name, "name")}
          label="Name"
          minRows={1}
        />
      </div>
      <ConnectedTextarea
        name={getFieldPath(name, "description")}
        label="Description"
        minRows={1}
      />
    </div>
  );
  let primaryContent = primaryFields;

  const actionComp = (
    <div className="flex flex-row items-center">
      <CopyCode
        label={""}
        value={id}
        customClasses={{
          value:
            "token-monospace f6 lh-copy word-break-all pa2 bg-content--secondary ba br2 hairline-1 w-100"
        }}
        tooltip="Copy product id"
        toast={"Copied product id to clipboard"}
      />
      <StripeExternalLink
        account={account}
        tooltip={VIEW_ON_STRIPE}
        copy={` `}
        href={getStripeDestination({ path: `products/${id}` })}
      />
    </div>
  );

  return (
    <SectionBezel header="Details" action={actionComp}>
      {primaryContent}
    </SectionBezel>
  );
};

export default DetailsFields;
